'use client';

import { c as _c } from "react/compiler-runtime";
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import { benefitsForIncludedPlanModal, IncludedPlanBenefitItem } from '../../_components/IncludedPlanBenefitsDialog';
import { BENEFITS as BASIC_PLAN_BENEFITS } from '../GroupMentoring/Options';
type BenefitItem = {
  lead: string;
  rest: string;
};
export const INDIVIDUAL_PLAN_BENEFITS: BenefitItem[] = [{
  lead: 'Wszystko z planu mentoringu podstawowego',
  rest: 'Dostajesz pełen pakiet mentoringu podstawowego, więc nic nie tracisz.'
}, {
  lead: 'Regularne spotkania 1:1 z mentorem',
  rest: 'Wybierasz od 2 do 10 godzin co 4 tygodnie, dopasowane do Twoich pytań i tempa'
}, {
  lead: 'Maks. 5 uczniów na mentora',
  rest: 'Masz pewność, że mentor ma czas i głowę na Twój konkretny przypadek'
}, {
  lead: 'Spersonalizowany plan nauki',
  rest: 'Razem ustalacie cel, kolejność tematów i tempo. Nie ma dwóch takich samych planów'
}, {
  lead: 'Własne projekty',
  rest: 'Budujesz i rozwijasz to, co sam wymyślisz, a mentor pomaga Ci na każdym etapie'
}, {
  lead: 'Przegląd kodu przez mentora',
  rest: 'Mentor regularnie sprawdza kod, który piszesz. Mówi wprost, co jest dobrze, a co warto zmienić'
}, {
  lead: 'Narzędzia AI w cenie',
  rest: 'Dostajesz licencje i kredyty do płatnych narzędzi AI o wartości do 200 zł miesięcznie, a mentor uczy Cię aktualnych standardów pracy ze sztuczną inteligencją'
}, {
  lead: 'Gwarancja zwrotu pieniędzy',
  rest: 'Jeśli po miesiącu współpracy nie spełnimy Twoich oczekiwań, zwracamy Ci 100% kosztów - szczegóły w regulaminie'
}];
const [includedBasicPlan, ...individualOnlyBenefits] = INDIVIDUAL_PLAN_BENEFITS;
export function IndividualPlanBenefits() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="space-y-4"><li key={includedBasicPlan.lead}><IncludedPlanBenefitItem lead={includedBasicPlan.lead} rest={includedBasicPlan.rest} dialogTitle="Mentoring podstawowy zawiera" sections={[{
          benefits: benefitsForIncludedPlanModal(BASIC_PLAN_BENEFITS)
        }]} /></li>{individualOnlyBenefits.map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(t0) {
  const {
    lead,
    rest
  } = t0;
  return <li key={lead}><IconOnTheLeftWithContentLayout mainContent={<P2 className="text-contentSecondary"><strong className="block font-semibold text-contentPrimary">{lead}</strong>{rest}</P2>} /></li>;
}